import {CheckOutlined, WarningOutlined} from "@ant-design/icons";

export const messages = {
    required: <span><WarningOutlined type="info-circle"/> Պարտադիր լրացման դաշտ</span>,
    documentError: <span><WarningOutlined type="info-circle"/> Փաստաթուղթը չի կցվել</span>,
    incorrectFormat: <span><WarningOutlined type="info-circle"/> Սխալ ֆորմատ</span>,
    count: <span><WarningOutlined type="info-circle"/> Տեղեկատվությունը սխալ է լրացված</span>,
    personIdentified: <span style={{ fontSize: '16px', color: 'green' }}><CheckOutlined /> Անձը նույնականացվել է</span>,
    personNotIdentified: <span style={{fontSize: '16px', color: 'red'}}><WarningOutlined type="info-circle"/> Անձը չի նույնականացվել</span>
}